import type { HttpClient } from "@/core/services/protocols/types";
import { IGithubGateway } from "./GithubGateway";
import Novidade, { INotificationResponse } from "./Novidade";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";

@injectable()
export default class GithubHttpGateway implements IGithubGateway {
  @inject(DITypes.GITHUB_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async getNovidades(): Promise<Novidade | undefined> {
    const response = await this.httpClient.get<
      INotificationResponse[] | undefined
    >({
      url: "https://raw.githubusercontent.com/f360-dev/novidades-f360/main/financas/novidades.json"
    });

    if (response.statusCode !== 200) {
      return;
    }

    return new Novidade(response.body);
  }
}
